import React from "react";
import {
  CourseContainer,
  CourseTitle,
  CourseTitleContainer,
  LessonList,
  LessonListWrapper,
  OpenCourseLink,
} from "./style";

import { LessonCard } from "../../../newUXComponents/LessonCard";
import { FormattedMessage } from "react-intl";
import useEventCode from "../../../hooks/useEventCode";

const CourseList = ({ courses }) => {
  const eventCode = useEventCode();

  return (
    <CourseContainer>
      {courses.map((course, index) => {
        if (course.lessons.length === 0) return null;
        return (
          <div key={index}>
            <CourseTitleContainer>
              <CourseTitle>{course.courseTitle}</CourseTitle>
              <OpenCourseLink
                to={`/informa-academy/${eventCode}/course/${course.courseId}`}
              >
                <FormattedMessage id="homepage.open_course" />
              </OpenCourseLink>
            </CourseTitleContainer>
            <LessonListWrapper>
              <LessonList>
                {course.lessons.map((lesson, index) => (
                  <LessonCard
                    key={index}
                    lesson={lesson}
                    courseId={course.courseId}
                    lessonId={lesson.lessonId}
                    index={index}
                    icon={true}
                    noHover
                  />
                ))}
              </LessonList>
            </LessonListWrapper>
          </div>
        );
      })}
    </CourseContainer>
  );
};

export default CourseList;
